import { Link } from "react-router-dom";
import { Lock, Sparkles, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function PaywallGate({ title = "Complete Access required", subtitle, ctaLabel = "Unlock for $6.95" }) {
  const { user } = useAuth();
  // Once a member has paid, never show paywall promos to them again.
  if (user?.has_complete_access) return null;
  return (
    <div
      className="relative glass-card p-10 lg:p-14 text-center overflow-hidden"
      data-testid="paywall-gate"
    >
      <div className="absolute inset-0 dot-grid opacity-30 pointer-events-none" />
      <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#7DA3D9]/8 rounded-full blur-3xl pointer-events-none" />

      <div className="relative">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-[#7DA3D9]/30 bg-[#7DA3D9]/5 mb-6">
          <Lock className="w-6 h-6 text-[#7DA3D9]" />
        </div>
        <div className="overline mb-2">Members only · One-time $6.95</div>
        <h2 className="font-display text-3xl lg:text-4xl tracking-tight">{title}</h2>
        {subtitle && (
          <p className="text-slate-300 mt-4 max-w-xl mx-auto leading-relaxed">{subtitle}</p>
        )}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/upgrade"
            className="btn-gold inline-flex items-center gap-2"
            data-testid="paywall-unlock-btn"
          >
            <Sparkles className="w-4 h-4" />
            {ctaLabel}
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <p className="text-xs text-slate-500 mt-5">
          Lifetime access · No recurring charges · Secure Stripe checkout
        </p>
      </div>
    </div>
  );
}
